import styles from '@/styles/WorkInfo.module.scss'
import { useLoginValue } from '@/hooks/useLoginValue'
import axios from 'axios'
import { useRef, useEffect, useState, useMemo, useCallback } from 'react'
import {
  lastDayOfMonth,
  getDay,
  isMatch,
  subWeeks,
  getWeekOfMonth,
  parse,
  addHours,
  format,
  isEqual,
  isSameDay,
  isSaturday,
  isSunday,
  subDays,
  isAfter,
  getMonth,
  getYear,
  isBefore,
  compareDesc,
  parseISO,
  setHours,
  isValid,
} from 'date-fns'
import ko from 'date-fns/locale/ko'
import { BsImage } from 'react-icons/bs'
import { FaCheckCircle } from 'react-icons/fa'
import { IoMdSave } from 'react-icons/io'
import Loader from '@/components/Loader'
import { supabase } from '@/client'
import TimePicker from 'react-time-picker'
import { ClipLoader } from 'react-spinners'

export const WorkInfo = ({ handleStatus }) => {
  const { ipcRenderer } = window.electron

  const { userInfo, specialDays, setSpecialDays, isWorkInfoLoaded, setIsWorkInfoLoaded, transparencyRange, setTransparencyRange } =
    useLoginValue()
  const [userData, setUserData] = useState()

  const [newOffTime, setNewOffTime] = useState('')

  const [today, setToday] = useState(new Date())

  // Refresh Day: 월의 마지막 금요일 (마지막 금요일이 공휴일인 경우 전 주를 마지막 금요일로 세팅)
  const [holidays, setHolidays] = useState([])
  const DATE_FORMAT = 'yyyy-MM-dd'
  const TIME_FORMAT = 'HH:mm:ss'
  const TIME_FORMAT_CONVERT = 'HH:mm'
  const [policy, setPolicy] = useState()
  const [refreshDay, setRefreshDay] = useState()
  // const isRefreshDay = useMemo(() => {
  //   return refreshDay && isSameDay(today, refreshDay)
  // }, [refreshDay, today])
  const parsedHolidayDates = useMemo(() => {
    return holidays.map((holiday) => parse(holiday.start, DATE_FORMAT, new Date()))
  }, [userData, holidays])
  const getRefreshDay = useCallback(() => {
    const lastDay = lastDayOfMonth(today)
    const dayOfWeek = 5

    const fridayHolidays = parsedHolidayDates.filter((holiday) => {
      return getDay(holiday) === dayOfWeek
    })

    let rDay = null
    let broke = false
    for (let i = lastDay.getDate(); i >= 1; i--) {
      if (broke) {
        break
      }
      const date = new Date(lastDay.getFullYear(), lastDay.getMonth(), i)
      if (getDay(date) === dayOfWeek) {
        if (!fridayHolidays.find((f) => isEqual(f, date))) {
          rDay = date
          broke = true
          break
        }
        for (let j = 0; j <= fridayHolidays.length - 1; j++) {
          if (fridayHolidays.includes(rDay) && isEqual(date, fridayHolidays[j])) {
            rDay = subWeeks(date, j + 1)
            break
          }
        }
      }
    }
    setRefreshDay(rDay)
  }, [userData, parsedHolidayDates, today])

  const [payDay, setPayDay] = useState()
  const isPayDay = useMemo(() => {
    return payDay && isSameDay(today, payDay)
  }, [payDay, today])

  // 월급날
  const getPayDay = useCallback(() => {
    const dayOffDates = [...parsedHolidayDates]

    const lastDay = lastDayOfMonth(today)

    let oDay = null
    let broke = false
    for (let i = lastDay.getDate(); i >= 1; i--) {
      if (broke) {
        break
      }
      const date = new Date(lastDay.getFullYear(), lastDay.getMonth(), i)
      if (!isSaturday(date) && !isSunday(date)) {
        if (!dayOffDates.find((f) => isEqual(f, date))) {
          oDay = date
          broke = true
          break
        }
        for (let j = 0; j <= dayOffDates.length - 1; j++) {
          if (dayOffDates.includes(oDay) && isEqual(date, dayOffDates[j])) {
            oDay = subDays(date, j + 1)
            break
          }
        }
      }
    }
    setPayDay(oDay)
  }, [userData, parsedHolidayDates, today])

  const workStartParsedTime = useMemo(() => {
    if (userData?.workDate && userData?.workStTime) {
      return parse(`${userData.workDate} ${userData.workStTime}`, `${DATE_FORMAT} ${TIME_FORMAT}`, new Date())
    } else {
      return ''
    }
  }, [userData])

  const workEndParsedTime = useMemo(() => {
    if (userData?.workEdTime) {
      // ISO 형식 문자열을 Date 객체로 파싱
      const parsedDate = parseISO(userData.workEdTime)
      return isValid(parsedDate) ? parsedDate : ''
    }
    return ''
  }, [userData])

  const isLate = useMemo(() => {
    if (userData?.workDate && policy) {
      return isAfter(workStartParsedTime, parse(`${userData.workDate} ${policy.workEndTime}`, `${DATE_FORMAT} ${TIME_FORMAT}`, new Date()))
    }
  }, [userData, workStartParsedTime, policy])

  const getOffTime = useMemo(() => {
    if (userData?.workDate && policy) {
      // 정규 퇴근시간 계산
      // const computedGetOffTime = addHours(workStartParsedTime, policy.workingTime)

      // const standardGetOffTime = addHours(parseISO(`${format(today, DATE_FORMAT)}T${policy.workStartTime}`), policy.workingTime)
      // 출근시간이 기준 출근시간(workStartTime 보다 빠른 경우 기준 퇴근시간으로 적용)
      // const isBeforeStandardGetOffTime = isBefore(computedGetOffTime, standardGetOffTime)
      // return isRefreshDay
      //   ? isLate
      //     ? format(addHours(workStartParsedTime, policy.refreshDayWorkingTime), TIME_FORMAT_CONVERT)
      //     : format(new Date(`2023-01-01T${policy.refreshWorkEndTime}`), TIME_FORMAT_CONVERT)
      //   : isBeforeStandardGetOffTime
      //   ? format(standardGetOffTime, TIME_FORMAT_CONVERT)
      //   : format(computedGetOffTime, TIME_FORMAT_CONVERT)
      // return isBeforeStandardGetOffTime ? standardGetOffTime : computedGetOffTime

      return workEndParsedTime
    }
    return ''
  }, [workStartParsedTime, isLate, policy, today, userData])

  const formattedGetOffTime = useMemo(() => {
    return getOffTime && isValid(getOffTime) ? format(getOffTime, TIME_FORMAT_CONVERT) : ''
  }, [getOffTime])

  useEffect(() => {
    ipcRenderer.send('getOffTime', formattedGetOffTime)
    setNewOffTime(formattedGetOffTime)
  }, [formattedGetOffTime])

  const getWorkTime = useMemo(() => {
    if (userData?.workDate && isValid(workStartParsedTime)) {
      return format(workStartParsedTime, TIME_FORMAT_CONVERT)
    }
  }, [workStartParsedTime])

  const getWorkInfo = async () => {
    const URI = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_WORK_API_URL}/api` : process.env.REACT_APP_WORK_API_URL
    const allUsersDTO = await axios.get(`${URI}/users`)
    const curUsrIdHash = allUsersDTO.data.users.find((user) => user.email === userInfo.email).userIdHash
    const allUsrTimeTrackingDTO = await axios.get(`${URI}/time-tracking`)
    const curUsrTimeTrackingRecord = allUsrTimeTrackingDTO.data.payload.records.find((item) => item.userIdHash === curUsrIdHash)
    const isOnWorkDay = !!curUsrTimeTrackingRecord.records[0]
    const { data: expectedData } = await supabase.from('work_schedule').select('expected_end_time').eq('user_id', userInfo.id)

    // TODO 결근, 연차, 재택근무 여부 분기 필요
    const workInfo = {
      name: userInfo.name,
      workDate: curUsrTimeTrackingRecord?.records?.[0]?.appliedDate || null,
      workStTime: format(
        new Date(curUsrTimeTrackingRecord?.records?.[0]?.workClockRecordPacks?.[0]?.startRecord?.targetTime || 0),
        TIME_FORMAT
      ),
      workEdTime: expectedData[0]?.expected_end_time || null,
      workType: isOnWorkDay ? '정상 출근' : '결근',
      isOnWorkDay,
    }

    // workStartTime이 없으면 알림 띄우기
    if (!workInfo?.isOnWorkDay) {
      ipcRenderer.send('showWorkStartTimeWarning')
    }

    setUserData(workInfo)
    ipcRenderer.send('workInfo', {
      curUsrWorkInfo: workInfo,
      allUsrs: allUsersDTO.data.users,
      allUsrTimeTracking: allUsrTimeTrackingDTO.data.payload.records,
      timestamp: allUsersDTO.data.timestamp,
    })
  }

  const setKoHolidays = useCallback(async () => {
    const currentYear = getYear(today)
    const currentMonth = format(today, 'MM')

    const { data: customHolidays } = await supabase
      .from('customHolidays')
      .select('summary, start, end, is_holiday, show_notification, emoji, id')
      .like('start', `${currentYear}-${currentMonth}-%`)

    ipcRenderer.send(
      'notiDays',
      customHolidays
        ?.filter((customHoliday) => isSameDay(parseISO(customHoliday.start), today) && customHoliday.show_notification)
        .map((customHoliday) => {
          return { id: customHoliday.id, icon: customHoliday.emoji, text: customHoliday.summary }
        })
    )

    const { data: policyData = [] } = await supabase.from('policy').select('policy_id, time')
    setPolicy(
      policyData
        ?.map((policyItem) => {
          return {
            [policyItem['policy_id']]: policyItem.time,
          }
        })
        .reduce((prev, curr) => {
          return Object.assign(prev, curr)
        }, {})
    )

    const lastDay = lastDayOfMonth(today)
    const DISCOVERY_DOC = 'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'
    window.gapi.load('client', async () => {
      await window.gapi.client.init({
        apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
        discoveryDocs: [DISCOVERY_DOC],
      })
      const data = await window.gapi.client.calendar.events.list({
        calendarId: 'ko.south_korea#holiday@group.v.calendar.google.com',
        timeMin: today.toISOString(),
        timeMax: new Date(lastDay).toISOString(),
        showDeleted: false,
        singleEvents: true,
        maxResults: 30,
        orderBy: 'starttime',
      })

      setHolidays(
        data.result.items
          .map((item) => ({
            summary: item.summary,
            start: item.start.dateTime || item.start.date,
            end: item.end.dateTime || item.end.date,
          }))
          .concat((customHolidays || []).filter((customHoliday) => customHoliday.is_holiday))
          .sort((a, b) => {
            return compareDesc(parseISO(a.start), parseISO(b.start))
          })
      )
      setIsWorkInfoLoaded(true)
    })
  }, [today])

  useEffect(() => {
    getRefreshDay()
  }, [holidays])

  useEffect(() => {
    ipcRenderer.send('fetchData')

    const fetchWorkInfoHandler = (event, command) => {
      const updatedDate = new Date()
      setToday(updatedDate)
      const useCacheFlag = command?.workDate && isSameDay(parse(command?.workDate, DATE_FORMAT, new Date()), updatedDate)
      // TODO 캐시 설정을 왜 했을까
      // if (!command || !useCacheFlag) {
      getWorkInfo()
      // } else {
      //   setUserData({ ...command })
      // }
    }

    ipcRenderer.on('fetchWorkInfo', fetchWorkInfoHandler)

    return () => {
      ipcRenderer.removeListener('fetchWorkInfo', fetchWorkInfoHandler)
    }
  }, [])

  useEffect(() => {
    setIsWorkInfoLoaded(false)
    if (userData?.workType === '결근') {
      setIsWorkInfoLoaded(true)
      return
    }
    if (userData) {
      setKoHolidays()
      getPayDay()
    }
  }, [userData])

  useEffect(() => {
    setSpecialDays({ ...specialDays, ...{ pay: isPayDay, late: isLate } })
  }, [isPayDay, isLate])

  function handleTransparencyChange(event) {
    const value = event.target.value
    setTransparencyRange(value)
    ipcRenderer.send('transparency', value)
  }

  const [imgWidgetSrc, setImgWidgetSrc] = useState('')
  const [isShowImgWidget, setIsShowImgWidget] = useState(false)
  const changeImgWidget = () => {
    ipcRenderer.send('changeImgWidget')
  }

  const errorHandler = (message = null) => {
    setNewOffTime(formattedGetOffTime)
    handleStatus({ type: 'error', message })
    getWorkInfo()
    setEditStatus('')
  }

  const [editStatus, setEditStatus] = useState(null)
  const updateOffTime = async () => {
    inputWrapEl.current.focus()
    inputWrapEl.current.blur()

    if (!newOffTime) {
      errorHandler('시간을 올바르게 입력해주세요.')
      return
    }

    const parsedNewTime = parse(`${userData.workDate} ${newOffTime}`, `${DATE_FORMAT} ${TIME_FORMAT_CONVERT}`, new Date())
    if (isValid(parsedNewTime) && isValid(workStartParsedTime) && isBefore(parsedNewTime, workStartParsedTime)) {
      errorHandler('퇴근시간은 출근시간보다<br /> 늦은 시간으로 설정해주세요.')
      return
    }

    if (newOffTime !== formattedGetOffTime) {
      setEditStatus('loading')

      // timestampz 형식으로 변환
      const expectedEndDateTime = parse(`${userData.workDate} ${newOffTime}:00`, `${DATE_FORMAT} ${TIME_FORMAT}`, new Date())
      if (!isValid(expectedEndDateTime)) {
        errorHandler('날짜/시간 형식이 올바르지 않습니다.')
        return
      }
      const expectedEndTimestampz = expectedEndDateTime.toISOString()

      // 먼저 레코드가 존재하는지 확인
      const { data: existingRecord, error: selectError } = await supabase.from('work_schedule').select('id').eq('user_id', userInfo.id)

      if (selectError) {
        console.error('Supabase select error:', selectError)
        errorHandler('관리자에게 문의해주세요.')
        return
      }

      // 레코드가 없으면 INSERT, 있으면 UPDATE
      let result
      if (!existingRecord || existingRecord.length === 0) {
        console.log('No existing record found, inserting new record')
        result = await supabase
          .from('work_schedule')
          .insert([{ user_id: userInfo.id, expected_start_time: null, expected_end_time: expectedEndTimestampz }])
      } else {
        console.log('Existing record found, updating')
        result = await supabase
          .from('work_schedule')
          .update({ expected_start_time: null, expected_end_time: expectedEndTimestampz, updated_at: new Date().toISOString() })
          .eq('user_id', userInfo.id)
      }

      const { data, error, status, statusText } = result

      console.log(data, error, status, statusText, '🏃🏃🏃🏃🏃')

      if (error) {
        console.error('Supabase error:', error)
        errorHandler('관리자에게 문의해주세요.')
        return
      }

      const parsedNewOffTime = parse(`${userData.workDate} ${newOffTime}`, `${DATE_FORMAT} ${TIME_FORMAT_CONVERT}`, new Date())
      ipcRenderer.send('getOffTime', isValid(parsedNewOffTime) ? format(parsedNewOffTime, TIME_FORMAT_CONVERT) : newOffTime)
      getWorkInfo()
      setTimeout(() => {
        setEditStatus('complete')
      }, 500)
      setTimeout(() => {
        setEditStatus('fading')
      }, 2500)
      setTimeout(() => {
        setEditStatus('')
      }, 3000)
    } else {
      setEditStatus('')
    }
  }

  const inputWrapEl = useRef(null)

  useEffect(() => {
    ipcRenderer.send('isShowImgWidget')
    ipcRenderer.send('getImgWidgetFilename')

    const isShowImgWidgetHandler = (event, command) => {
      setIsShowImgWidget(command)
    }
    const imgWidgetFilenameHandler = (event, command) => {
      command && setImgWidgetSrc(`data:image/jpeg;base64,${command}`)
    }

    ipcRenderer.on('isShowImgWidget', isShowImgWidgetHandler)
    ipcRenderer.on('imgWidgetFilename', imgWidgetFilenameHandler)

    return () => {
      ipcRenderer.removeListener('isShowImgWidget', isShowImgWidgetHandler)
      ipcRenderer.removeListener('imgWidgetFilename', imgWidgetFilenameHandler)
    }
  }, [])

  return isWorkInfoLoaded ? (
    <div className={styles['work-info']}>
      <div className={styles['work-info__view-box']}>
        <div className="flex flex-col">
          {userData?.workType !== '결근' ? (
            <>
              <div className="flex h-[21px]">
                <span className="-mt-0.5 w-5">👩🏼‍💻</span>
                <span className="font-medium text-sm">출근 {getWorkTime}</span>
              </div>
              <div className="flex items-top mt-1">
                <span className="-ml-1 mr-1 w-5 scale-x-[-1]">🏃🏼</span>

                <div className="flex items-center" tabIndex="0" ref={inputWrapEl}>
                  <span className="font-medium text-sm">퇴근</span>
                  <div className="ml-1 h-[21px] font-medium text-sm">
                    <TimePicker
                      className="cursor-pointer"
                      format={TIME_FORMAT_CONVERT}
                      locale="en-EN"
                      value={newOffTime}
                      disableClock={true}
                      clearIcon={null}
                      onChange={setNewOffTime}
                      onFocus={() => setEditStatus('editing')}
                      onKeyUp={(e) => {
                        if (e.key === 'Enter') {
                          updateOffTime()
                        }
                        if (e.key === 'Escape') {
                          setNewOffTime(formattedGetOffTime)
                          inputWrapEl.current.focus()
                          inputWrapEl.current.blur()
                          setEditStatus('')
                        }
                      }}
                    />
                  </div>
                  {editStatus === 'editing' && (
                    <button type="button" className="-mt-0.25 ml-1.5" onClick={updateOffTime}>
                      <IoMdSave />
                    </button>
                  )}
                  {editStatus === 'loading' && (
                    <div className="ml-1.5">
                      <ClipLoader size="12" color="rgba(255, 255, 255, 0.5)" />
                    </div>
                  )}
                  {(editStatus === 'complete' || editStatus === 'fading') && (
                    <div
                      className={`-mt-0.25 ml-1.5 transition-opacity duration-500 ${editStatus === 'fading' ? 'opacity-0' : 'opacity-100'}`}
                    >
                      <FaCheckCircle />
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <div className="flex items-start">
              <span className="c-list__emoji -mt-1">👀</span>
              <span className="text-sm">결근</span>
            </div>
          )}
        </div>
        {isShowImgWidget && (
          <div className={`${styles['work-info__img-box']} ${!imgWidgetSrc ? styles['s-register'] : ''}`}>
            {imgWidgetSrc && <img src={imgWidgetSrc} alt="" onError={() => setImgWidgetSrc('')} />}
            <button type="button" onClick={changeImgWidget} className={`${styles['work-info__img-btn']}`}>
              <BsImage />
            </button>
          </div>
        )}
      </div>

      <div className={styles['work-info-etc']}>
        <div className={styles['work-info-etc__item']}>
          <span className={styles['work-info-etc__txt']} title={userData.name}>
            {userData.name}
          </span>
        </div>
        <div className={styles['work-info-etc__item']}>
          <span className={styles['work-info-etc__txt']}>{format(today, `${DATE_FORMAT} (eee)`, { locale: ko })}</span>
        </div>
        <div className={styles['work-info-etc__item']}>
          <input
            type="range"
            id="volume"
            name="volume"
            min="1"
            max="10"
            value={transparencyRange}
            className={styles['work-info-etc__range-input']}
            onChange={handleTransparencyChange}
          />
        </div>
      </div>
    </div>
  ) : (
    <Loader />
  )
}
